import { ReloadOutlined } from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Empty,
  Input,
  Menu,
  Pagination,
  Row,
  Space,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { Link, withRouter } from 'react-router-dom'
import TableComponent from '../../components/Common/TableComponent'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import AppPageHeader from '../../components/AppPageHeader'
import UnreadTextOutGoing from '../../components/UnreadText/UnreadTextOutGoing'
import config from '../../config'
import {
  ACL_ACTION_TYPE,
  DATE_FORMAT_DEFAULT,
  DATE_FORMAT_LIST,
  ISO_DATE_FORMAT,
  MODULE_CODE,
  getDOCUMENT_SAME_STATUS_RECEIVED,
} from '../../constants'
import DashboardLayout from '../../layouts/DashboardLayout'
import PopupLoginAccount from '../SameDocumentIncomingDocPage/PopupLoginAccount'
import AdvanceFilterBlock from './AdvanceFilterBlock'
import {
  SearchBar,
  TableFooterActionWrapper,
} from './SameDocumentOutgoingDocPageStyled'
const { Search } = Input
const { RangePicker } = DatePicker
const { systemName } = config

const SameDocumentOutgoingDocPage = props => {
  const {
    history,
    loadingAnimationStore,
    authenticationStore,
    moduleStore,
    aclStore,
    sameDocumentStore,
  } = props

  const { currentUser } = authenticationStore
  const { isSuperAdmin, isAccountAdmin } = authenticationStore
  const { aclActionsByUser } = aclStore
  const { isAccessControl } = moduleStore

  const SCROLL_WIDTH = 1150

  const [showAdvanceFilter, setShowAdvanceFilter] = useState(false)
  const [disabledSearchBtn, setDisabledSearchBtn] = useState(true)
  const [filterByKeyword, setFilterByKeyword] = useState('')
  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)
  const [fromDate, setFromDate] = useState(moment().format(ISO_DATE_FORMAT))
  const [toDate, setToDate] = useState(moment().format(ISO_DATE_FORMAT))
  const [reload, setReload] = useState(false)
  const [isOpenLoginModal, setisOpenLoginModal] = useState(false)
  const [tableLoading, setTableLoading] = useState(false)
  let [searchOptionTitle, setSearchOptionTitle] = useState('')
  let [searchOption, setSearchOption] = useState({
    bussiness_doc_type: undefined,
    status: undefined,
    title: undefined,
    page: 0,
    size: 10,
  })

  const [reloadLoading, setReloadLoading] = useState(false)
  // check hiển thị phân trang khi load dữ liệu
  const [checkPagination, setCheckPagination] = useState(true)

  const queryStringParse = queryString.parse(location.search)

  const tableColumns = [
    {
      title: 'Số hiệu',
      width: 130,
      render: record => (
        <UnreadTextOutGoing
          text={record.documentNumber}
          isUnread={checkUnread(record)}
          width={130}
        />
      ),
    },
    {
      title: 'Trích yếu',
      width: 400,
      render: record => (
        <UnreadTextOutGoing
          text={record.title}
          isUnread={checkUnread(record)}
          width={400}
        />
      ),
    },
    {
      title: 'Cơ quan ban hành',
      width: 200,
      render: record => (
        <UnreadTextOutGoing
          text={record.authorityIssuedName}
          isUnread={checkUnread(record)}
          width={200}
        />
      ),
    },
    {
      title: 'Trạng thái',
      width: 80,
      render: record => (
        <UnreadTextOutGoing
          text={getDOCUMENT_SAME_STATUS_RECEIVED(record?.status)}
          isUnread={checkUnread(record)}
          width={80}
        />
      ),
    },
    {
      title: 'Ngày ban hành',
      width: 100,
      render: record =>
        record.dateIssued ? (
          <UnreadTextOutGoing
            text={moment(record.dateIssued).format(DATE_FORMAT_DEFAULT)}
            isUnread={checkUnread(record)}
            width={100}
          />
        ) : null,
    },
  ]

  const checkUnread = record => !record.firstDateRead

  const reloadData = () => {
    setReloadLoading(true)
    let params = {
      from_date: fromDate,
      to_date: toDate,
      type: 'SAME_OUTGOING',
    }
    sameDocumentStore
      .reload(params)
      .then(() => {
        message.success('Làm mới dữ liệu thành công')
        fetchData()
      })
      .catch(() => {
        setisOpenLoginModal(true)
      })
      .finally(() => setReloadLoading(false))
  }

  const handleSearch = values => {
    const { status, bussiness_doc_type, title } = values

    /** Kiểm tra việc reload lại trang để lấy lại list vb */
    if (title || bussiness_doc_type || status) {
      setReload(true)
    } else {
      setReload(false)
    }

    loadingAnimationStore.setTableLoading(true)
    sameDocumentStore
      .getDocumentsIncoming(searchOption)
      .finally(() => loadingAnimationStore.setTableLoading(false))
    setDisabledSearchBtn(true)
  }

  const onQuickSearch = useCallback(title => {
    let newSearchOption = {
      ...searchOption,
      ...{
        page: 0,
        title: title ? title.trim() : undefined,
      },
    }
    setSearchOption(newSearchOption)
    setDisabledSearchBtn(true)
  }, [])
  const onChangePagination = pageIndex => {
    let newSearchOption = {
      ...searchOption,
      ...{
        page: pageIndex - 1,
      },
    }
    setSearchOption(newSearchOption)
  }

  useEffect(() => {
    fetchData()
  }, [currentUser, searchOption, aclActionsByUser])

  const fetchData = useCallback(async () => {
    if (!currentUser) return
    if (aclActionsByUser.length === 0) return
    if (
      !isSuperAdmin &&
      !isAccountAdmin &&
      !isAccessControl(
        MODULE_CODE.same_document,
        ACL_ACTION_TYPE.menu__SAME_DOCUMENT,
        aclActionsByUser
      )
    ) {
      history.push('/dashboard')
      message.error(
        'Bạn không có quyền truy cập trang này, vui lòng liên hệ admin'
      )
      return
    }
    setTableLoading(true)
    await setCheckPagination(false)
    sameDocumentStore
      .getDocumentsOutgoing(searchOption)
      .then(res => {
        setList(res.data.data)
        setTotal(res.data.total_count)
      })
      .finally(() => {
        setTableLoading(false)
        setCheckPagination(true)
      })
  }, [
    currentUser,
    searchOption,
    aclActionsByUser,
    isSuperAdmin,
    isAccountAdmin,
    history,
  ])

  // const handleChangeParams = params => {
  //     const currentPage = queryParamsIncoming.page || 0
  //     const updatedParams = {
  //       ...queryParamsIncoming,
  //       page: params.page !== undefined ? params.page : currentPage,
  //       ...params,
  //     }
  //     internalDocumentStore.setQueryParamsIncoming(updatedParams)
  //     const queryStringStringify = queryString.stringify(
  //       {
  //         ...queryStringParse,
  //         page: updatedParams.page,
  //         size: updatedParams.size || 10,
  //         ...params,
  //       },
  //       { skipNull: true }
  //     )
  //     history.replace(
  //       `/internal-document/incoming-document?${queryStringStringify}`,
  //       {
  //         ...history.location.state,
  //         page: updatedParams.page,
  //         size: updatedParams.size || 10,
  //         onlyUnread: updatedParams.only_unread,
  //       }
  //     )
  //   }

  const onChangeIncomingDate = value => {
    setFromDate(value ? moment(value[0]).format(ISO_DATE_FORMAT) : '')
    setToDate(value ? moment(value[1]).format(ISO_DATE_FORMAT) : '')
  }
  return (
    <DashboardLayout>
      <AppPageHeader
        title="Văn bản đi"
        addon={
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {!showAdvanceFilter ? (
              <Search
                size="large"
                className="rounded-search"
                style={{ width: 300 }}
                allowClear
                onSearch={onQuickSearch}
                defaultValue={searchOptionTitle}
                placeholder={'Tìm kiếm văn bản theo trích yếu'}
                onChange={e => {
                  setSearchOptionTitle(e.target.value)
                }}
                value={searchOptionTitle}
              />
            ) : null}
            <RangePicker
              size="large"
              onChange={onChangeIncomingDate}
              defaultValue={[moment(), moment()]}
              placeholder={['Từ ngày', 'Đến ngày']}
              format={DATE_FORMAT_LIST}
              style={{ width: 250 }}
            />
            {aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.lam_moi__SAME_DOCUMENT
            ) && (
              <Button size="large" loading={reloadLoading} onClick={reloadData}>
                <ReloadOutlined />
                Làm mới dữ liệu
              </Button>
            )}
          </div>
        }
      />
      <ContentBlockWrapper>
        <Menu
          mode="horizontal"
          selectedKeys={'outgoing-document'}
          style={{ marginBottom: 16 }}>
          <Menu.Item key="incoming-document">
            <Link to={'/same-document/incoming-document'}>Văn bản đến</Link>
          </Menu.Item>
          <Menu.Item key="outgoing-document">
            <Link to={'/same-document/outgoing-document'}>Văn bản đi</Link>
          </Menu.Item>
        </Menu>
        <Helmet>
          <title>Văn bản đi | {systemName} Trục đồng bộ</title>
        </Helmet>
        <div>
          {showAdvanceFilter ? (
            <>
              <AdvanceFilterBlock
                onChangeSearchForm={value => {
                  setSearchOption(Object.assign(searchOption, value))
                  setDisabledSearchBtn(false)
                }}
                handleSearch={handleSearch}
                titleSearch={filterByKeyword}
                disabledSearchBtn={disabledSearchBtn}
              />
            </>
          ) : null}
          <TableComponent
            onRow={record => {
              return {
                onClick: () =>
                  history.push(
                    `/same-document/outgoing-document/view/${record.code}`
                  ),
              }
            }}
            rowKey={record => record.code}
            dataSource={list}
            columns={tableColumns}
            pagination={false}
            scroll={{ x: SCROLL_WIDTH }}
            locale={{
              emptyText:
                checkPagination === true ? (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={'Không có dữ liệu'}
                  />
                ) : (
                  <div style={{ opacity: 0.1, height: '150px' }} />
                ),
            }}
            loading={tableLoading}
          />
          <TableFooterActionWrapper>
            {checkPagination === true ? (
              <Pagination
                onChange={e => onChangePagination(e)}
                pageSize={searchOption.size}
                showSizeChanger={false}
                showLessItems
                current={searchOption.page + 1}
                total={total}
                hideOnSinglePage={true}
              />
            ) : (
              ''
            )}
          </TableFooterActionWrapper>
        </div>
      </ContentBlockWrapper>
      <PopupLoginAccount
        isVisible={isOpenLoginModal}
        onClose={() => setisOpenLoginModal(false)}
        onLoginSuccess={() => {
          setisOpenLoginModal(false)
          reloadData()
        }}
      />
    </DashboardLayout>
  )
}

SameDocumentOutgoingDocPage.propTypes = {}

export default memo(
  withRouter(
    inject(
      'loadingAnimationStore',
      'authenticationStore',
      'moduleStore',
      'aclStore',
      'sameDocumentStore'
    )(observer(SameDocumentOutgoingDocPage))
  )
)
